import { render, staticRenderFns } from "./photo-acceptance.vue?vue&type=template&id=c0adb5e8&scoped=true&lang=pug&"
import script from "./photo-acceptance.vue?vue&type=script&lang=js&"
export * from "./photo-acceptance.vue?vue&type=script&lang=js&"
import style0 from "./photo-acceptance.vue?vue&type=style&index=0&id=c0adb5e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0adb5e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0adb5e8')) {
      api.createRecord('c0adb5e8', component.options)
    } else {
      api.reload('c0adb5e8', component.options)
    }
    module.hot.accept("./photo-acceptance.vue?vue&type=template&id=c0adb5e8&scoped=true&lang=pug&", function () {
      api.rerender('c0adb5e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/photos/acceptance/photo-acceptance.vue"
export default component.exports